const buttons = {
    apple: {
        icon: 'app-download-apple',
        href: 'https://apps.apple.com/ru/app/%D0%BC%D0%BE%D0%B9-%D0%BD%D0%B0%D0%BB%D0%BE%D0%B3/id1437518854?l=en',
        content: 'App Store',
    },
    google: {
        icon: 'app-download-google',
        href: 'https://play.google.com/store/apps/details?id=com.gnivts.selfemployed&hl=ru',
        content: 'Google Play',
    },
    rustore: {
        icon: 'app-download-rustore',
        href: 'https://apps.rustore.ru/app/com.gnivts.selfemployed',
        content: 'RuStore',
    },
    appgalery: {
        icon: 'app-download-appgalery',
        href: 'https://appgallery.huawei.ru/app/C106258161',
        content: 'App Galery',
    },
} as const;

export default buttons;
